module.exports = __webpack_public_path__ + "img/titleIcon.9a44cebf.svg";